import { ShiftType } from "page/ManageShiftStaff/type";
import { memo } from "react";
import { SHIFT_TYPES } from "constant";
import { background } from "@chakra-ui/react";
import { hexToRgba } from "utils";
interface IProps {
  disabled: boolean;
  indexCol: number;
  row: number;
  date: string;
  nurseId: number;
  id?: number;
  shiftType?: ShiftType;
  note?: string | null;
  isBlur?: boolean
}

const ShiftCard = ({
  disabled,
  indexCol,
  row,
  date,
  nurseId,
  shiftType,
  note,
  isBlur
}: IProps) => {
const alpha = isBlur ? 0.1 : 1
  const style = shiftType && SHIFT_TYPES[shiftType]
    ? { background: hexToRgba(SHIFT_TYPES[shiftType].color , alpha), border: `1.5px solid  ${hexToRgba(SHIFT_TYPES[shiftType].border, alpha)}`, color: isBlur? "black": "white" }
    : {};

  return (
    <div style={{ ...style }} className="h-full box-border">
      <div
        className={`w-full flex justify-center items-center flex-col h-full select-none text-[#fff] ${
          disabled
            ? "cursor-not-allowed"
            : `staff_schedule staff_schedule_row${row} cursor-pointer`
        }`}
        data-indexcol={indexCol}
        data-indexrow={row}
        data-date={date}
        data-note={note ? note : ""}
        data-nurseid={nurseId}
        data-shifttype={shiftType || ""}
      >
        {shiftType && SHIFT_TYPES[shiftType]
          ? SHIFT_TYPES[shiftType].label.split("").map((x, index) => (
              <p className="select-none" key={index} style={{ color: isBlur ? "black" : "white" }}>
                {x}
              </p>
            ))
          : ""}
      </div>
    </div>
  );
};

export default memo(ShiftCard);
